import { z } from "zod";

export const DeploymentAnnouncementSchema = z.object({
  deploymentId: z
    .string()
    .min(1)
    .describe(
      "Identifier of the finished deployment; the frontend it shipped is built with the same value.",
    ),
});
